import { Component, Prop, h, Host, State, Element, Listen, Watch } from '@stencil/core';

@Component({
  tag: 'pn-bonus-progressbar-level',
  styleUrl: 'pn-bonus-progressbar-level.scss',
})
export class PnBonusProgressbarLevel {
  @Element() hostElement: HTMLElement;

  @Prop({ reflect: true }) current: boolean = false;
  @Prop({ reflect: true, mutable: true }) value: number = 0;
  @Prop({ reflect: true, mutable: true }) bonuspercentage: string = '';
  @Prop({ reflect: true, mutable: true }) visualpercentage: number = 0;

  @State() percentage: number = 0;

  @State() max: number = 0;
  @State() min: number = 0;
  @State() currency: string = '';

  componentWillLoad() {
    this.max = parseInt(this.hostElement.parentElement.parentElement.getAttribute('max'), 10);
    this.min = parseInt(this.hostElement.parentElement.parentElement.getAttribute('min'), 10);
    this.currency = this.hostElement.parentElement.parentElement.getAttribute('currency');
    this.percentage = (this.value / this.max) * 100;

    if (this.visualpercentage > 0) {
      // Visual percentage has been overriden
      return;
    }
    this.visualpercentage = this.value === 0 ? 0 : ((this.value - this.min) / (this.max - this.min)) * 100;
  }
  formatValue() {
    return `${this.value.toLocaleString('sv-SE', { maximumFractionDigits: 0 })} ${this.currency}`;
  }
  render() {
    return (
      <Host style={{ left: `${this.visualpercentage}%` }}>
        <div class="progressbar-level-percentage">{this.bonuspercentage}</div>
        <div class="progressbar-level-value">{this.formatValue()}</div>
      </Host>
    );
  }
}
